import { Link, useNavigate } from 'react-router-dom';

export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <div className="not-found">
      <h1>403</h1>
      <p>Você não tem permissão para acessar esta página.</p>
      <p className="muted small">Se acredita que isso é um erro, contate um administrador.</p>
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', marginTop: '1rem' }}>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate(-1)}>
          ← Voltar
        </button>
        <Link to="/" className="btn btn-secondary btn-sm">
          Ir ao início
        </Link>
      </div>
    </div>
  );
}
